<template>
  <el-drawer
    ref="drawerRef"
    :title="title"
    size="55%"
    :with-header="true"
    :visible="drawer"
    v-bind="$attrs"
    :before-close="handleClosed"
    @closed="handleClosed"
  >
    <div style="padding: 50px">
      <!-- cuando el cliente se haya ganado -->
      <div style="margin-bottom: 50px" v-if="win">
        <el-col :span="11">
          <label
            >CLIENTE GANADO:
            <b> {{ company }}</b>
          </label>
        </el-col>

        <el-col :span="11">
          <label
            >OPORTUNIDAD NO.
            <b> {{ dealId }}</b>
          </label>
        </el-col>
      </div>

      <!-- cuando el cliente se haya perdido -->
      <div style="margin-bottom: 50px" v-if="!win">
        <el-col :span="11">
          <label
            >CLIENTE PERDIDO:
            <b> {{ company }}</b>
          </label>
        </el-col>

        <el-col :span="11">
          <label
            >OPORTUNIDAD NO.
            <b> {{ dealId }}</b>
          </label>
        </el-col>
      </div>

      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="200px"
        class="demo-ruleForm"
        label-position="left"
      >
        <el-form-item label="Empresa que ganó" required>
          <el-col :span="11">
            <el-form-item prop="name">
              <el-input
                size="medium"
                style="width: 100%"
                v-model="ruleForm.name"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-form-item>

        <el-form-item label="Precio que ofertó" prop="price">
          <el-input-number
            v-model="ruleForm.price"
            :controls="false"
            :min="1"
          ></el-input-number>
        </el-form-item>

        <el-form-item label="Fecha de renovación de contrato" required>
          <el-col :span="12">
            <el-form-item prop="date">
              <el-date-picker
                type="date"
                placeholder="Pick a date"
                v-model="ruleForm.date"
                style="width: 100%"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-form-item>

        <el-form-item label="Cantidad de dispositivos" prop="devices">
          <el-input-number
            v-model="ruleForm.devices"
            :min="1"
            :controls="false"
          ></el-input-number>
        </el-form-item>

        <el-form-item label="Más detalles">
          <el-col :span="12">
            <el-form-item prop="details">
              <el-input
                type="textarea"
                placeholder="Ingrese las compañias que participaron con su precio de oferta ejemplo:
                Tennos Business - 1500"
                v-model="ruleForm.details"
                style="width: 100%"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-form-item>

        <el-form-item label="¿Que pude haber hecho mejor?" required v-if="!win">
          <el-col :span="12">
            <el-form-item prop="question1">
              <el-input
                size="medium"
                style="width: 100%"
                v-model="ruleForm.question1"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-form-item>

        <el-form-item
          label="¿Como la empresa pudo apoyarme que no lo hizo?"
          required
          v-if="!win"
        >
          <el-col :span="12">
            <el-form-item prop="question2">
              <el-input
                size="medium"
                style="width: 100%"
                v-model="ruleForm.question2"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-form-item>

        <el-form-item style="float: right">
          <el-button type="primary" @click="submitForm(ruleForm)">
            Create
          </el-button>
          <!-- <el-button type="danger" @click="submitForm(ruleForm)" v-if="!win"
            >Create</el-button
          > -->
          <el-button @click="resetForm('ruleForm')">Reset</el-button>
        </el-form-item>
      </el-form>
    </div>
  </el-drawer>
</template>

<script>
export default {
  name: "DealsFormDeclined",
  props: {
    drawer: {
      type: Boolean,
      default: false
    },
    dealId: {
      type: Number,
      default: 0
    },
    dataNextPhase: {
      type: Object,
      default: function () {
        return {};
      }
    },
    company: {
      type: String,
      default: ""
    },
    win: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ""
    }
  },
  async created() {},
  data() {
    return {
      ruleForm: {
        name: "",
        price: "",
        date: "",
        devices: "",
        details: "",
        question1: "",
        question2: ""
      },
      rules: {
        name: [
          {
            required: true,
            message: "Por favor ingrese el nombre de la empresa que ganó",
            trigger: "blur"
          }
        ],
        price: [
          {
            required: true,
            message: "Por favor ingrese el precio que ofertó la empresa",
            trigger: "change"
          }
        ],
        date: [
          {
            type: "date",
            required: true,
            message: "Por favor ingrese la fecha de renovación de contrato",
            trigger: "change"
          }
        ],
        devices: [
          {
            required: true,
            message: "Por favor ingrese la cantidad de dispositivos",
            trigger: "change"
          }
        ],
        question1: [
          {
            required: true,
            message: "Por favor responda esta pregunta",
            trigger: "blur"
          }
        ],
        question2: [
          {
            required: true,
            message: "Por favor responda esta pregunta",
            trigger: "blur"
          }
        ]
        // details: [
        //   {
        //     required: true,
        //     message:
        //       "Por favor ingrese las empresas que participaron con su precio de oferta",
        //     trigger: "change"
        //   }
        // ]
      }
    };
  },
  methods: {
    submitForm(formDate) {
      // console.log(formDate);
      // DealReportWinOrDeclined;
      let isValid = false;
      this.$refs["ruleForm"].validate((valid) => {
        isValid = valid;
      });

      if (!isValid) return false;

      if (this.win) {
        this.$confirm("Segura/o que desea marcar el registro como ganada ?")
          .then(() => {
            this.$http
              .get("/api/deals/DealReportWinOrDeclined", {
                params: {
                  DealId: this.dealId,
                  ClientName: this.company,
                  CompanyName: formDate.name,
                  Equipments: formDate.devices,
                  Price_Offer: formDate.price,
                  Date_Renovation: formDate.date,
                  Companys_Participated: formDate.details,
                  Win: this.win,
                  Options: "A"
                },
                timeout: 3 * 60 * 100
              })
              .then((resp) => {
                //console.log("commente2: ", resp.data)
                if (resp.data) {
                  this.$message({
                    type: "success",
                    message: "Reporte agregado exitosamente!"
                  });

                  this.$http
                    .post("/api/deals/win", this.dataNextPhase)
                    .then(() => {
                      this.$store.commit("setSplashScreen", false);
                      this.$store.commit("deals/MOVE_DEAL", {
                        from: 5,
                        to: 6,
                        deal: this.dealId
                      });
                      this.$message.success("Oportunidad ganada.");
                      this.$emit("close-drawer");
                    })
                    .catch((error) => {
                      console.error(error);
                      this.$message.error("Error al cambiar la etapa.");
                    });

                  this.$emit("close-drawer");
                } else {
                  this.$message.error("Error al agregar Reporte");
                }
              })
              .catch((error) => {
                //console.log("commente2 catch: ", error)
                this.$message.error("Error al agregar Reporte", error);
              });
          })
          .catch(() => {});
        return;
      }

      // this.$prompt(
      //   "Indicar el porque",
      //   "Segura/o que desea declinar este registro ?",
      //   {
      //     confirmButtonText: "OK",
      //     cancelButtonText: "Cancel",
      //     inputValidator: (el) => {
      //       if (el === null) {
      //         return false;
      //       }
      //     },
      //     inputErrorMessage: "Mensaje es requerido",
      //     inputType: "textarea"
      //   }
      // )
      this.$confirm("Segura/o que desea marcar el registro como ganada ?")
        .then(({ value }) => {
          this.$http
            .get("/api/deals/DealReportWinOrDeclined", {
              params: {
                DealId: this.dealId,
                ClientName: this.company,
                CompanyName: formDate.name,
                Equipments: formDate.devices,
                Price_Offer: formDate.price,
                Date_Renovation: formDate.date,
                Companys_Participated: formDate.details,
                Win: this.win,
                Options: "A"
              },
              timeout: 3 * 60 * 100
            })
            .then((resp) => {
              //console.log("commente2: ", resp.data)
              if (resp.data) {
                this.$message({
                  type: "success",
                  message: "Reporte agregado exitosamente!"
                });

                this.$http
                  .post("/api/deals/cancel", {
                    DealID: this.dealId,
                    Reason: value,
                    question1: formDate.question1,
                    question2: formDate.question2
                  })
                  .then(({ data }) => {
                    this.$store.commit("deals/MOVE_DEAL", {
                      from: data.From,
                      to: data.To,
                      deal: data.Deal,
                      question1: formDate.question1,
                      question2: formDate.question2
                    });

                    this.$store.commit("setSplashScreen", false);
                    this.$message.success("Oportunidad cancelada");
                  })
                  .catch((error) => {
                    console.error(error);
                    this.$message.error("Error al cancelar la oportunidad");
                  });

                this.$emit("close-drawer");
              } else {
                this.$message.error("Error al agregar Reporte");
              }
            })
            .catch((error) => {
              //console.log("commente2 catch: ", error)
              this.$message.error("Error al agregar Reporte", error);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Cancelada"
          });
        });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    handleClosed() {
      this.$emit("close-drawer");
    }
  }
};
</script>
